import { reducedStream, dispatchAction } from '@ardoq/rxbeach';
import { map } from 'rxjs';
import { changeActiveTab, toggleShowDetails, copyToClipboard } from './actions';
import { reducers } from './reducers';
import { ImportApiPayloadDrawerState, TabType } from './types';
import { ASYNC_STATUS } from '../../types/api';

const initialState: ImportApiPayloadDrawerState = {
  asyncStatus: ASYNC_STATUS.INIT,
  payload: null,
  errorDetails: null,
  activeTab: 'objects',
  copiedTab: null,
  showDetails: false,
};

export const importApiPayloadDrawer$ = reducedStream(
  'importApiPayloadDrawer$',
  initialState,
  reducers
).pipe(
  map(state => ({
    ...state,
    onChangeActiveTab: (newTab: TabType) =>
      dispatchAction(changeActiveTab(newTab)),
    onCopyToClipboard: () => dispatchAction(copyToClipboard(state.activeTab)),
    onToggleShowDetails: () => dispatchAction(toggleShowDetails()),
  }))
);
